import styled from 'styled-components'
import { PictureAsPdf } from '@styled-icons/material/PictureAsPdf'

export const IconWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
`

export const PrintInvoiceIcon = styled(PictureAsPdf)`
  width: 34px;
  cursor: pointer;
`

export const PrintArea = styled.div`
  display: none;

  @media print {
    display: block;
  }
`
